import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH MAIN_ITEM COVER_DETAIL FILES TO EDIT ********************
export const fetchMainItemCoverDetail = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_MAIN_ITEM_COVER_DETAIL_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=packet&collection=cover_detail`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_MAIN_ITEM_COVER_DETAIL_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_MAIN_ITEM_COVER_DETAIL_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
